<template>
  <div class="mobile">
    <img class="iconInfo" src="./../../assets/iconInfo.png" />
    <div class="row-1">
      为了保证良好的体验
      <br />请在PC端打开项目信息站
    </div>
    <div class="row-2">项目信息站地址：https://pip.itcast.cn</div>
  </div>
</template>
<style>
body{
  min-width: auto !important;
}
</style>
<style lang="scss" scoped>
.mobile {
  width: 100%;
  max-height: 720px;
  text-align: center;
  padding-top: 125px;
  .iconInfo {
    width: 53px;
    height: 53px;
    // background: rgba(16, 174, 255, 1);
  }
  .row-1 {
    margin: 0 auto;
    padding-top: 27px;
    width: 194px;
    // height: 48px;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    line-height: 24px;
  }
  .row-2 {
    margin: 0 auto;
    padding-top: 21px;
    width: 300px;
    // height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
}
</style>

<script>
export default {
  name: "Mobile"
};
</script>
